import { Gis } from "./Gis";
import GisRepository from "./GisRepository";

export default class GisService {
    private readonly gisRespository: GisRepository = new GisRepository();

    async uploadGis(data: Gis): Promise<boolean> {
        return this.gisRespository.uploadGis(data);
    }

    async deleteGis(gisId: number): Promise<boolean> {
        return this.gisRespository.deleteGis(gisId);
    }
}
